<template>
  <div class="w-full sm:w-112 p-6 pt-12 flex flex-col gap-2 items-center">
    <h3 class="text-4xl font-bold">Your {{ itemName }} is ready to share! 🎉</h3>
    <p class="text-xs">Psst. A link is always copied to your clipboard right after capture.</p>
    <Button type="solid" variant="blue" icon="general.copy" @click.prevent="() => copy()">Copy link</Button>
    <HorizontalDivider class="w-full" />
    <p class="text-2xl font-bold max-w-[15rem]">Now, try pasting that link in Slack, Teams or in an email...</p>
    <ImageSvg class="mt-4 max-w-[335px] sm:max-w-full" name="firstItem.illustration" />
  </div>
</template>

<script setup lang="ts">
import { computed, watch, Ref } from 'vue';
import { storeToRefs } from 'pinia';
import { Button, HorizontalDivider, ImageSvg } from '@/storybook';
import { useViewerItemStore, ActionType } from './../../store/useViewerItemStore';
import { useClipboard } from '@vueuse/core';
import { useToast } from '@/composables/useToast';

const capitalize = (s: string) => s && s[0].toUpperCase() + s.slice(1);
const { actionType, shareLink } = storeToRefs(useViewerItemStore());
const { copy, copied } = useClipboard({ source: shareLink as Ref });
const { success } = useToast();

watch(copied, res => {
  if (!res) {
    return;
  }

  success(`${capitalize(itemName.value)} link copied to clipboard`, { icon: 'general.copy' });
});

const itemName = computed(() => {
  switch (actionType.value) {
    case ActionType.ANNOTATED_VIDEO:
    case ActionType.VIDEO:
      return 'video';
    case ActionType.GIF:
    case ActionType.TRANSCODED_GIF:
    case ActionType.ANNOTATED_GIF:
      return 'gif';
    case ActionType.BOOKMARK:
      return 'bookmark';
    case ActionType.AUDIO:
      return 'audio';
    case ActionType.ANNOTATED_SCREENSHOT:
    case ActionType.SCREENSHOT:
      return 'screenshot';
    case ActionType.FILE_UPLOAD:
      return 'file';
    default:
      return 'item';
  }
});
</script>

<style scoped></style>
